import { httpClient } from '@/Common/api/http_client';

// =========================================
// Merchant Specific APIs starts
/**
 *
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getAllRoles() {
  return httpClient.get('/roles');
}

/**
 *
 * @param roleId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function deleteRole(roleId) {
  return httpClient.delete(`/roles/${roleId}`);
}

/**
 *
 * @param roleId
 * @param role
 * @returns {Promise<AxiosResponse<T>>}
 */
export function updateRole(roleId, role) {
  return httpClient.put(`/roles/${roleId}`, role);
}

/**
 *
 * @param role
 * @returns {Promise<AxiosResponse<T>>}
 */
export function newRole(role) {
  return httpClient.post('/roles', role);
}

// Merchant Specific APIs ends
// =========================================
